import { VoteOption } from '@/components/features/VoteOption/VoteOption';

import type { Poll } from '@/types/poll';

import styles from './PollResults.module.css';

interface PollResultsProps {
    poll: Poll;
    selectedOptions: number[];
    onSelectOption: (optionId: number) => void;
    hasVoted: boolean;
    disabled: boolean;
}

export function PollResults({
    poll,
    selectedOptions,
    onSelectOption,
    hasVoted,
    disabled,
}: PollResultsProps) {
    const sortedOptions = [...poll.options].sort((a, b) => a.order - b.order);

    return (
        <div className={styles.container}>
            {sortedOptions.map((option, index) => (
                <VoteOption
                    key={option.id}
                    option={option}
                    pollType={poll.poll_type}
                    totalVotes={poll.total_votes}
                    isSelected={selectedOptions.includes(option.id)}
                    hasVoted={hasVoted}
                    disabled={disabled}
                    onSelect={onSelectOption}
                    index={index}
                    isQuiz={poll.is_quiz}
                />
            ))}
        </div>
    );
}
